if (!customElements.get('slynara-ref57-waitlist')) {
  customElements.define(
    'slynara-ref57-waitlist',
    class SlynaraRef57Waitlist extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.variants = this.readVariants();
        this.handleChange = this.handleChange.bind(this);
        this.productInfo?.addEventListener('change', this.handleChange);
        this.updateSelection();
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.handleChange);
        if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
      }

      handleChange(event) {
        if (!event.target.closest('variant-selects')) return;
        if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
        this.updateFrame = requestAnimationFrame(() => this.updateSelection());
      }

      readVariants() {
        try {
          return JSON.parse(this.querySelector('[data-ref57-waitlist-variants]')?.textContent || '[]');
        } catch {
          return [];
        }
      }

      updateSelection() {
        const picker = [...(this.productInfo?.querySelectorAll('variant-selects') || [])].find(
          (element) => element.style.display !== 'none'
        );
        if (!picker) return;

        const checked = [...picker.querySelectorAll('input[type="radio"]:checked')];
        const controls = checked.length ? checked : [...picker.querySelectorAll('select')];
        const options = controls.map((control) => control.value).filter(Boolean);
        const variant = this.variants.find(
          (item) => item.options.length === options.length && item.options.every((option, index) => option === options[index])
        );
        if (!variant) return;

        const label = variant.options.join(' / ');
        const selection = this.querySelector('[data-ref57-waitlist-selection]');
        const variantInput = this.querySelector('[data-ref57-waitlist-variant]');
        const variantIdInput = this.querySelector('[data-ref57-waitlist-variant-id]');
        const messageInput = this.querySelector('[data-ref57-waitlist-message]');
        if (selection) selection.textContent = label;
        if (variantInput) variantInput.value = label;
        if (variantIdInput) variantIdInput.value = variant.id;
        if (messageInput) messageInput.value = `Waitlist request for Deep Plunge Bodysuit — ${label}`;
        this.updateAvailability(Boolean(variant.available));
      }

      updateAvailability(available) {
        const quantity = this.productInfo?.querySelector('[data-ref57-quantity]');
        const buyArea = this.productInfo?.querySelector('[data-ref57-buy-area]');
        quantity?.toggleAttribute('hidden', !available);
        buyArea?.toggleAttribute('hidden', !available);
        this.toggleAttribute('hidden', available);
      }
    }
  );
}
